"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = Image;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

// TODO: lazy load
function Image(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      getRef = _ref.getRef,
      itemScope = _ref.itemScope,
      itemType = _ref.itemType,
      itemProp = _ref.itemProp,
      onLoad = _ref.onLoad,
      src = _ref.src,
      bgImage = _ref.bgImage,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'img' : _ref$role;
  return /*#__PURE__*/_react["default"].createElement(bgImage ? 'div' : 'img', {
    className: className,
    onLoad: onLoad,
    alt: alt,
    role: role,
    itemScope: itemScope,
    itemType: itemType,
    itemProp: itemProp,
    ref: getRef,
    src: !bgImage && src || undefined,
    style: bgImage && {
      backgroundImage: "url(" + src + ")"
    } || undefined
  });
}

Image.propTypes = {
  alt: _propTypes["default"].string,
  className: _propTypes["default"].string,
  getRef: _propTypes["default"].func,
  onLoad: _propTypes["default"].func,
  src: _propTypes["default"].string.isRequired,
  itemScope: _propTypes["default"].bool,
  itemType: _propTypes["default"].string,
  itemProp: _propTypes["default"].string,
  bgImage: _propTypes["default"].bool,
  role: _propTypes["default"].string
};